export default "__VITE_ASSET__0c4c082a__"